import * as CspApi from '../csp-api';

declare global {
    interface Window {
        Csp: typeof CspApi;
    }
}

if (window) {
    window.Csp ??= CspApi;
}

// this module needs a export, for declare blocks to take effect
export const Csp = window.Csp;
